import { render } from "./mvt-saleproceeds.vue?vue&type=template&id=b7d23068"
import script from "./mvt-saleproceeds.js?vue&type=script&lang=js"
export * from "./mvt-saleproceeds.js?vue&type=script&lang=js"

import "./mvt-saleproceeds.vue?vue&type=style&index=0&id=b7d23068&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__